import Vue from 'vue';
import Vuex from 'vuex';

import {auth} from './auth.module';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth
    },
    getters: {
        isAdmin: state => {
            return state.auth.user.roles.includes('ROLE_ADMIN');
        },
        isManager: (state) => (portal) => {
            return portal.managers.find(manager => manager === state.auth.user.email)
        }
    }
});